var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApiCog01 = function SvgApiCog01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "api_cog-01_svg2__a",
    x1: 48.66,
    x2: 155.39,
    y1: 164.65,
    y2: 30.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__b",
    x1: 48.66,
    x2: 155.39,
    y1: 164.65,
    y2: 30.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__c",
    x1: 50.89,
    x2: 157.62,
    y1: 166.42,
    y2: 32.02
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__d",
    x1: 39.06,
    x2: 145.79,
    y1: 157.03,
    y2: 22.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__e",
    x1: 65.94,
    x2: 172.67,
    y1: 178.37,
    y2: 43.97
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__f",
    x1: 31.16,
    x2: 137.89,
    y1: 150.75,
    y2: 16.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__g",
    x1: 29.34,
    x2: 136.07,
    y1: 149.31,
    y2: 14.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__h",
    x1: 61.45,
    x2: 168.18,
    y1: 174.81,
    y2: 40.41
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#api_cog-01_svg2__a",
    id: "api_cog-01_svg2__i",
    x1: 63.36,
    x2: 170.09,
    y1: 176.33,
    y2: 41.93
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m192.63 121.17-6.9-3.98c1.16-5.76 1.74-11.53 1.74-17.18s-.58-11.51-1.72-17.2l6.87-3.97a9.15 9.15 0 0 0 4.29-5.58c.64-2.37.31-4.85-.92-6.98L177.2 33.74a9.15 9.15 0 0 0-5.58-4.29 9.12 9.12 0 0 0-6.98.92l-6.88 3.97c-8.68-7.64-18.91-13.55-29.79-17.23v-7.9c0-5.07-4.13-9.2-9.2-9.2H81.2c-5.07 0-9.2 4.13-9.2 9.2v7.9c-10.82 3.66-21.03 9.59-29.75 17.26l-6.92-3.99a9.16 9.16 0 0 0-6.98-.92 9.13 9.13 0 0 0-5.58 4.29L4 66.27a9.16 9.16 0 0 0-.92 6.98 9.13 9.13 0 0 0 4.29 5.58l6.9 3.98c-1.16 5.76-1.74 11.53-1.74 17.18s.58 11.51 1.72 17.2l-6.87 3.97c-4.39 2.54-5.9 8.17-3.37 12.56l18.79 32.54c2.54 4.39 8.17 5.9 12.56 3.37l6.87-3.97c8.68 7.64 18.91 13.55 29.79 17.23v7.9c0 5.07 4.13 9.2 9.2 9.2h37.57c5.07 0 9.2-4.13 9.2-9.2v-7.9c10.82-3.66 21.03-9.59 29.75-17.26l6.92 3.99c4.39 2.54 10.03 1.03 12.56-3.37l18.79-32.54c2.54-4.39 1.03-10.03-3.37-12.56Zm-1.72 9.62-18.79 32.54c-.92 1.59-2.96 2.14-4.54 1.22l-8.76-5.06a2.93 2.93 0 0 0-3.46.39c-8.96 8.29-19.74 14.54-31.18 18.08a2.94 2.94 0 0 0-2.07 2.8v10.04c0 1.83-1.49 3.33-3.33 3.33H81.21c-1.83 0-3.33-1.49-3.33-3.33v-10.04c0-1.29-.84-2.42-2.07-2.8-11.51-3.56-22.3-9.81-31.22-18.06-.56-.51-1.27-.78-1.99-.78-.5 0-1.01.13-1.47.39l-8.72 5.04a3.32 3.32 0 0 1-4.54-1.22L9.08 130.79a3.32 3.32 0 0 1 1.22-4.54l8.72-5.03a2.94 2.94 0 0 0 1.4-3.19c-1.34-5.95-2.02-12.02-2.02-18.03s.69-11.97 2.05-18.01c.28-1.25-.28-2.55-1.4-3.19l-8.75-5.05a3.29 3.29 0 0 1-1.55-2.02c-.23-.86-.11-1.76.33-2.52l18.79-32.54c.44-.77 1.16-1.32 2.02-1.55s1.76-.11 2.52.33l8.76 5.06c1.11.64 2.52.49 3.46-.39 8.96-8.29 19.74-14.54 31.18-18.08a2.94 2.94 0 0 0 2.07-2.8V9.2c0-1.83 1.49-3.33 3.33-3.33h37.57c1.83 0 3.33 1.49 3.33 3.33v10.04c0 1.29.84 2.42 2.07 2.8 11.5 3.56 22.3 9.81 31.22 18.06.94.87 2.35 1.03 3.46.39l8.72-5.04c.77-.44 1.67-.56 2.52-.33.86.23 1.58.78 2.02 1.55l18.79 32.54c.44.77.56 1.67.33 2.52s-.78 1.58-1.55 2.02l-8.72 5.03a2.94 2.94 0 0 0-1.4 3.19c1.34 5.95 2.02 12.02 2.02 18.03s-.69 11.97-2.05 18.01c-.28 1.25.28 2.55 1.4 3.19l8.75 5.05c1.59.92 2.13 2.96 1.22 4.54",
    style: {
      fill: "url(#api_cog-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 40.7c-32.7 0-59.3 26.6-59.3 59.3s26.6 59.3 59.3 59.3 59.3-26.6 59.3-59.3-26.6-59.3-59.3-59.3m0 112.72c-29.46 0-53.42-23.97-53.42-53.42S70.55 46.58 100 46.58s53.42 23.97 53.42 53.42-23.97 53.42-53.42 53.42",
    style: {
      fill: "url(#api_cog-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.96 84.54H100c-1.62 0-2.94 1.31-2.94 2.94v25.05c0 1.62 1.31 2.94 2.94 2.94s2.94-1.31 2.94-2.94v-6.46h8.02c5.93 0 10.76-4.83 10.76-10.76s-4.83-10.76-10.76-10.76Zm0 15.66h-8.02v-9.78h8.02a4.89 4.89 0 0 1 0 9.78",
    style: {
      fill: "url(#api_cog-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.96 86.45a2.92 2.92 0 0 0-2.75-1.9h-3.13c-1.22 0-2.32.76-2.75 1.9l-9.39 25.05c-.57 1.52.2 3.21 1.72 3.78s3.21-.2 3.78-1.72l1.63-4.36h13.15l1.63 4.36a2.94 2.94 0 0 0 2.75 1.91c.34 0 .69-.06 1.03-.19a2.935 2.935 0 0 0 1.72-3.78zm-8.69 16.88 4.37-11.67 4.37 11.67h-8.75Z",
    style: {
      fill: "url(#api_cog-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.18 84.54c-1.62 0-2.94 1.31-2.94 2.94v25.05c0 1.62 1.31 2.94 2.94 2.94s2.94-1.31 2.94-2.94V87.48c0-1.62-1.31-2.94-2.94-2.94",
    style: {
      fill: "url(#api_cog-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 34.17c2.04.65 4.07 1.4 6.04 2.24.37.16.76.24 1.15.24 1.14 0 2.23-.67 2.7-1.79.63-1.49-.06-3.22-1.55-3.85a74 74 0 0 0-6.55-2.43 2.938 2.938 0 0 0-1.78 5.6Z",
    style: {
      fill: "url(#api_cog-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.32 133.03a2.933 2.933 0 1 0-5.15 2.81c1.22 2.23 2.57 4.43 4.01 6.53a2.93 2.93 0 0 0 4.08.75 2.93 2.93 0 0 0 .76-4.08 67 67 0 0 1-3.69-6.02Z",
    style: {
      fill: "url(#api_cog-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.99 168.82c-15.73-1.36-30.66-8.17-42.04-19.19a2.93 2.93 0 0 0-4.15.07 2.93 2.93 0 0 0 .07 4.15c12.35 11.96 28.55 19.35 45.62 20.83.09 0 .17.01.26.01 1.51 0 2.79-1.15 2.92-2.68a2.943 2.943 0 0 0-2.67-3.18Z",
    style: {
      fill: "url(#api_cog-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.24 38.08a2.94 2.94 0 0 0-4.08.77c-.91 1.34-.57 3.17.77 4.08 13.64 9.32 23.5 23.19 27.78 39.05a2.93 2.93 0 0 0 3.6 2.07 2.93 2.93 0 0 0 2.07-3.6c-4.64-17.21-15.34-32.26-30.13-42.37Z",
    style: {
      fill: "url(#api_cog-01_svg2__i)"
    }
  }));
};
export default SvgApiCog01;